import Vue from "vue";
import store from "./store";
import Router from "vue-router";
import Console from "./views/Console.vue";
import ConsoleLanding from "./views/ConsoleLanding.vue";
import ConsoleMain from "./views/ConsoleMain.vue";
import About from "./views/About.vue";
import Register from "./views/Register.vue";
import Login from "./views/Login.vue";
import AccountCreate from "./views/AccountCreate.vue";
import PropertyCreate from "./views/PropertyCreate.vue";
import Dashboard from "./views/Dashboard.vue";
import DashboardHome from "./views/DashboardHome.vue";
import HomepageHome from "./views/HomepageHome.vue";
import AccountHome from "./views/AccountHome.vue";
import PasswordChange from "./views/PasswordChange.vue";
import AccountEdit from "./views/AccountEdit.vue";
import PropertyEdit from "./views/PropertyEdit.vue";
import PropertyAlertCreate from "./views/PropertyAlertCreate.vue";
import PropertyAlertEdit from "./views/PropertyAlertEdit.vue";
import PropertyAlerts from "./views/PropertyAlerts.vue";
import DashboardFeedback from "./views/DashboardFeedback.vue";
import DashboardFeedbackByCategory from "./views/DashboardFeedbackByCategory.vue";
import DashboardFeedbackByCategoryByWords from "./views/DashboardFeedbackByCategoryByWords.vue";
import DashboardFeedbackSearch from "./views/DashboardFeedbackSearch.vue";
import Users from "./views/Users.vue";
import UserEdit from "./views/UserEdit.vue";
import UserCreate from "./views/UserCreate.vue";
import UserCreatePassword from "./views/UserCreatePassword.vue";
import UserResetPassword from "./views/UserResetPassword.vue";
import ResetPasswordInstructions from "./views/ResetPasswordInstructions.vue";
import ForgotPassword from "./views/ForgotPassword.vue";
import Submit from "./views/Submit.vue";
import Unauthorized from "./views/Unauthorized.vue";
import DashboardFeedbackJSCode from "./views/DashboardFeedbackJSCode.vue";
import DashboardFeedbackURLCode from "./views/DashboardFeedbackURLCode.vue";
import PropertyFeedbackFileUpload from "./views/PropertyFeedbackFileUpload.vue";
import AccountBilling from "./views/AccountBilling.vue";
import SubscriptionUpgrade from "./views/SubscriptionUpgrade.vue";
import AccountBillingCreate from "./views/AccountBillingCreate.vue";
import Survey from "./views/Survey.vue";
import DashboardFeedbackCustomerJourney from "./views/DashboardFeedbackCustomerJourney.vue";
import DashboardFeedbackByCustomerJourney from "./views/DashboardFeedbackByCustomerJourney.vue";
import DashboardFeedbackList from "./views/DashboardFeedbackList.vue";
import DashboardFeedbackSummaryList from "./views/DashboardFeedbackSummaryList.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "about",
      component: About
    },
    {
      path: "/console/",
      component: Console,
      children: [
        {
          path: "",
          component: ConsoleLanding
        },
        {
          path: "register",
          component: Register
        },
        {
          path: "login",
          component: Login
        },
        {
          path: "forgotpassword",
          component: ForgotPassword
        },
        {
          path: "signup/:token",
          component: UserCreatePassword
        },
        {
          path: "reset/:token",
          component: UserResetPassword
        },
        {
          path: "resetpasswordinstructions",
          component: ResetPasswordInstructions
        },
        {
          path: "hidden",
          component: HomepageHome
        },
        {
          path: "unauthorized",
          component: Unauthorized
        }
      ]
    },
    {
      path: "/console/submit",
      name: "submit",
      component: Submit
    },
    {
      path: "/console/survey/:token",
      name: "survey",
      component: Survey
    },
    {
      path: "/console/main",
      component: ConsoleMain,
      beforeEnter: (to, from, next) => {
        if (!store.getters.loggedIn) {
          console.log("no token");
          next("/console/login");
        } else {
          next();
        }
      },
      children: [
        {
          path: "",
          component: DashboardHome
        }
      ]
    },
    {
      path: "/console/account",
      component: ConsoleMain,
      beforeEnter: (to, from, next) => {
        if (!store.getters.loggedIn) {
          console.log("no token");
          next("/console/login");
        } else {
          next();
        }
      },
      children: [
        {
          path: "",
          component: AccountHome
        },
        {
          path: "upgradeplan",
          component: SubscriptionUpgrade
        },
        {
          path: "passwordchange",
          component: PasswordChange
        },
        {
          path: "users",
          component: Users
        },
        {
          path: "useredit",
          component: UserEdit
        },
        {
          path: "usercreate",
          component: UserCreate
        },
        {
          path: "billing/",
          component: AccountBilling
        },
        {
          path: "billing/create",
          component: AccountBillingCreate
        },
        {
          path: "accountcreate",
          component: AccountCreate
        },
        {
          path: "accountedit/:id",
          component: AccountEdit
        }
      ]
    },
    {
      path: "/console/dashboard",
      component: ConsoleMain,
      beforeEnter: (to, from, next) => {
        if (!store.getters.loggedIn) {
          console.log("no token");
          next("/console/login");
        } else {
          next();
        }
      },
      children: [
        {
          path: "",
          component: DashboardHome
        },
        {
          path: "property/create",
          component: PropertyCreate
        }
      ]
    },
    {
      path: "/console/dashboard/property",
      component: Dashboard,
      beforeEnter: (to, from, next) => {
        if (!store.getters.loggedIn) {
          console.log("no token");
          next("/console/login");
        } else {
          next();
        }
      },
      children: [
        {
          path: ":id/feedback",
          component: DashboardFeedback
        },
        {
          path: "feedback/search",
          component: DashboardFeedbackSearch,
          name: "dashboardFeedbackSearch"
        },
        {
          path: ":id/edit",
          component: PropertyEdit
        },
        {
          path: ":id/feedback/list",
          component: DashboardFeedbackList
        },
        {
          path: ":id/feedbacksummary/list",
          component: DashboardFeedbackSummaryList
        },
        {
          path: ":token/feedbackurlcode/:property_name",
          component: DashboardFeedbackURLCode
        },
        {
          path: ":token/feedbackjscode/:property_name",
          component: DashboardFeedbackJSCode
        },
        {
          path: ":id/feedback/category/:cat_id",
          component: DashboardFeedbackByCategory,
          name: "dashboardFeedbackByCategory"
        },
        {
          path: ":id/feedback/category/:cat_id/wordid/:word_id",
          component: DashboardFeedbackByCategoryByWords,
          name: "dashboardFeedbackByCategoryByWords"
        },
        {
          path: ":property_id/alertedit/:id",
          component: PropertyAlertEdit
        },
        {
          path: ":id/alertcreate",
          component: PropertyAlertCreate,
          name: "propertyalertcreate"
        },
        {
          path: ":id/alert",
          component: PropertyAlerts
        },
        {
          path: ":id/feedback/fileupload",
          component: PropertyFeedbackFileUpload
        },
        {
          path: ":id/feedback/customerjourney",
          component: DashboardFeedbackCustomerJourney
        },
        {
          path: ":id/feedback/customerjourney/:customer_journey_cat_id",
          component: DashboardFeedbackByCustomerJourney,
          name: "dashboardFeedbackByCustomerJourney"
        }
      ]
    }
  ]
});
